import React from "react";
import { useNavigate } from "react-router-dom";

interface IProps {
    id: string;
    className: string;
    long?: boolean;
}
function Paragraph(props: React.PropsWithChildren<IProps>) {
    const navigate = useNavigate();
    return (
        <div
            key={props.id} className={props.className}
        > 
            <div
                onClick={() => {navigate("/news/:" + props.id); }}
            >
                 {props.children}
            </div>
            <div className="clear"/>
            {props.long && <div onClick={() => navigate("/news/:idx")} className="backButton">Übersicht</div>}
        </div>
    );
};
export default (Paragraph);
